<template>
  <span v-if="standort" class="standort-logo" :title="standort">
    <img :src="logoSrc" :alt="standort" class="standort-logo-img" />
  </span>
  <span v-else class="standort-logo standort-logo-empty">-</span>
</template>

<script>
// Standort (location) badge for an order — renders the company logo instead of
// the plain text "Drückerei Koch" / "Tastomat".
//
// Site comes from the authoritative `pk_sb` column (set on import from the
// Prinance Standort field, and PK for the legacy DB which is Pritzwalk-only).
// Pass it via :pk-sb. Only when it's absent do we fall back to guessing from the
// order number (3rd char, or 2nd when it starts with a digit, === '0' → Koch).
// That guess is unreliable — sequential/test numbers don't encode the site — so
// `pk_sb` always wins when present.

const LOGOS = {
  'Drückerei Koch': '/logos/drueckerei-koch.png',
  'Tastomat':       '/logos/tastomat.png'
}

export default {
  name: 'StandortLogo',
  props: {
    orderNumber: { type: [String, Number], default: '' },
    pkSb:        { type: String, default: '' }   // 'pk' | 'sb' — authoritative
  },
  computed: {
    standort() {
      if (this.pkSb === 'pk') return 'Drückerei Koch'
      if (this.pkSb === 'sb') return 'Tastomat'
      // Fallback: derive from the order number only when pk_sb is missing.
      const num = String(this.orderNumber || '').trim()
      if (num.length < 2) return ''
      const idx = isNaN(Number(num.charAt(0))) ? 2 : 1
      if (num.length <= idx) return ''
      return num.charAt(idx) === '0' ? 'Drückerei Koch' : 'Tastomat'
    },
    logoSrc() {
      return LOGOS[this.standort] || ''
    }
  }
}
</script>

<style scoped>
.standort-logo {
  display: inline-flex;
  align-items: center;
}
.standort-logo-img {
  height: 22px;
  max-width: 130px;
  object-fit: contain;
  vertical-align: middle;
}
.standort-logo-empty {
  color: #999;
}
</style>
